import { useCurrentUser } from "../../../AuthWrapper2/hooks/useCurrentUser.js";
import { usePaginationState } from "../../../../hooks/usePaginationState/index.js";
import { useRPCServerEventHandler } from "../../../../hooks/useRPCServerEventHandler/index.js";
import { useMailStore } from "../../stores/MailStore.js";
import { useMailMessages } from "../../hooks/useMailMessages.js";
import { useEffect } from "react";
//#region src/modules/Mail/screens/hooks/useMessageListProvider.ts
/** This hook provides all the shared logic to display a MessageList view. Different component can import it and provide their own JSX for specific type of views (ie: sidebar, main screen) */
function useMessageListProvider() {
	const currentUser = useCurrentUser();
	const isSelectingMessages = useMailStore((state) => state.isSelectingMessages);
	const resetSelectedMessages = useMailStore((state) => state.resetSelectedMessages);
	const messageSearchValue = useMailStore((state) => state.messageSearchValue);
	const folder = useMailStore((state) => state.folder);
	const { recordsPerPage, setSkippedRecords, skippedRecords } = usePaginationState(`MailMessageFolder_${folder}`, { defaultRecordsPerPage: 25 }, [folder, messageSearchValue]);
	const { data, loading, refresh } = useMailMessages({
		folder,
		pagination: {
			limit: recordsPerPage,
			skip: skippedRecords
		},
		searchText: messageSearchValue
	});
	useEffect(() => {
		if (isSelectingMessages) resetSelectedMessages();
	}, [data?.mailMessages]);
	useRPCServerEventHandler("MailSent", () => {
		refresh();
	});
	useEffect(() => {
		refresh();
	}, [currentUser?.userClientMetadata.unread.mail]);
	return {
		loadingMessages: loading,
		mailMessages: data?.mailMessages,
		recordsPerPage,
		refreshMessages: refresh,
		setSkippedRecords,
		skippedRecords,
		totalMessages: data?.total
	};
}
//#endregion
export { useMessageListProvider };

//# sourceMappingURL=useMessageListProvider.js.map